<template>
    <div class="row g-2 mt-1">
        <slot></slot>
    </div>
</template>